import { Image } from '../models/image';

export function getLargeUrl(img: Image) {
    return img.formats.large?.url ?? img.url;
}

export function getSmallUrl(img: Image) {
    return img.formats.small?.url ?? img.formats.thumbnail?.url ?? img.url;
}